export default __webpack_public_path__ + "static/media/8941.47b94f31.svg";